function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Utility functions for transforming theme objects into different formats
 */

/**
 * Abbreviation mapping for common theme terms
 */
var ABBREVIATIONS = {
  background: "bg",
  foreground: "fg"
};

/**
 * Apply abbreviation rules to a single token-path segment. Shared by the CSS
 * var generator (`flattenObject`) and the seeds-react-system-props shim's
 * color-prop fallback, so the `--color-*` names each side produces can't drift.
 */
export function abbreviate(key) {
  return ABBREVIATIONS[key] || key;
}

/**
 * Flatten a nested object into a single-level object with kebab-case keys
 * Example: { button: { primary: { background: { base: '#fff' } } } }
 * Becomes: { 'button-primary-bg-base': '#fff' }
 */
export function flattenObject(obj) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "-";
  var result = {};
  function recurse(current) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (typeof current === "string" || typeof current === "number") {
      // Leaf node - create the final key
      var key = path.map(abbreviate).join(separator);
      result[key] = String(current);
    } else if (_typeof(current) === "object" && current !== null) {
      // Recurse into nested objects
      for (var _i = 0, _Object$entries = Object.entries(current); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        recurse(value, [].concat(_toConsumableArray(path), [_key]));
      }
    }
  }
  recurse(obj, prefix ? [prefix] : []);
  return result;
}

/**
 * Flatten colors with a 'color-' prefix for CSS variables
 */
export function flattenColors(colors) {
  return flattenObject(colors, "color");
}

/**
 * Flatten spacing with a 'space-' prefix
 */
export function flattenSpacing(space) {
  var flattened = {};

  // Space is already flat: { 0: '0px', 100: '2px', ... }
  // But it may have nested properties like 'space' and '-space'
  for (var _i2 = 0, _Object$entries2 = Object.entries(space); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    if (typeof value === "string") {
      flattened["space-".concat(key)] = value;
    }
  }
  return flattened;
}

/**
 * Flatten typography values for Tailwind
 */
export function flattenTypography(typography) {
  var result = {};
  for (var _i3 = 0, _Object$entries3 = Object.entries(typography); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
      key = _Object$entries3$_i[0],
      value = _Object$entries3$_i[1];
    if (_typeof(value) === "object" && value !== null && "fontSize" in value && "lineHeight" in value) {
      result[key] = [value.fontSize, {
        lineHeight: value.lineHeight
      }];
    }
  }
  return result;
}

/**
 * Flatten radii (border radius)
 */
export function flattenRadii(radii) {
  var flattened = {};
  for (var _i4 = 0, _Object$entries4 = Object.entries(radii); _i4 < _Object$entries4.length; _i4++) {
    var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
      key = _Object$entries4$_i[0],
      value = _Object$entries4$_i[1];
    if (typeof value === "string") {
      flattened[key] = value;
    }
  }
  return flattened;
}

/**
 * Flatten border widths
 */
export function flattenBorderWidths(borderWidths) {
  var flattened = {};
  for (var _i5 = 0, _Object$entries5 = Object.entries(borderWidths); _i5 < _Object$entries5.length; _i5++) {
    var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
      key = _Object$entries5$_i[0],
      value = _Object$entries5$_i[1];
    if (typeof value === "string") {
      flattened[key] = value;
    }
  }
  return flattened;
}

/**
 * Flatten shadows
 */
export function flattenShadows(shadows) {
  var flattened = {};
  for (var _i6 = 0, _Object$entries6 = Object.entries(shadows); _i6 < _Object$entries6.length; _i6++) {
    var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i6], 2),
      key = _Object$entries6$_i[0],
      value = _Object$entries6$_i[1];
    if (typeof value === "string") {
      flattened[key] = value;
    }
  }
  return flattened;
}

/**
 * Flatten font weights
 */
export function flattenFontWeights(fontWeights) {
  var flattened = {};
  for (var _i7 = 0, _Object$entries7 = Object.entries(fontWeights); _i7 < _Object$entries7.length; _i7++) {
    var _Object$entries7$_i = _slicedToArray(_Object$entries7[_i7], 2),
      key = _Object$entries7$_i[0],
      value = _Object$entries7$_i[1];
    if (typeof value === "string" || typeof value === "number") {
      flattened[key] = value;
    }
  }
  return flattened;
}

/**
 * Flatten easing (transition timing functions)
 */
export function flattenEasing(easing) {
  var flattened = {};
  for (var _i8 = 0, _Object$entries8 = Object.entries(easing); _i8 < _Object$entries8.length; _i8++) {
    var _Object$entries8$_i = _slicedToArray(_Object$entries8[_i8], 2),
      key = _Object$entries8$_i[0],
      value = _Object$entries8$_i[1];
    if (typeof value === "string") {
      flattened[key] = value;
    }
  }
  return flattened;
}

/**
 * Flatten duration (transition durations)
 */
export function flattenDuration(duration) {
  var flattened = {};
  for (var _i9 = 0, _Object$entries9 = Object.entries(duration); _i9 < _Object$entries9.length; _i9++) {
    var _Object$entries9$_i = _slicedToArray(_Object$entries9[_i9], 2),
      key = _Object$entries9$_i[0],
      value = _Object$entries9$_i[1];
    if (typeof value === "string") {
      flattened[key] = value;
    }
  }
  return flattened;
}

/**
 * Check if a value is a valid CSS color
 * Filters out complex values like color-mix() which may not work everywhere
 */
export function isSimpleColor(value) {
  return !value.includes("color-mix") && !value.includes("gradient");
}

/**
 * Filter out colors that use advanced CSS features
 */
export function filterComplexColors(colors) {
  var filtered = {};
  for (var _i0 = 0, _Object$entries0 = Object.entries(colors); _i0 < _Object$entries0.length; _i0++) {
    var _Object$entries0$_i = _slicedToArray(_Object$entries0[_i0], 2),
      key = _Object$entries0$_i[0],
      value = _Object$entries0$_i[1];
    if (isSimpleColor(value)) {
      filtered[key] = value;
    } else {
      // Keep it but add a comment in generated files
      filtered[key] = value;
    }
  }
  return filtered;
}